module.exports = __webpack_public_path__ + "img/unimed-logo-1-hc.2b2e103f.png";